
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.33 4.47a.75.75 0 00-1.06 1.06l5.145 5.146a3 3 0 004.108 4.108l5.147 5.146a.75.75 0 101.06-1.06L5.33 4.47zm5.065 3.283A6.652 6.652 0 0112 7.55c2.224 0 4.305 1.217 5.885 2.527a17.846 17.846 0 012.15 2.123 17.835 17.835 0 01-2.15 2.123.75.75 0 10.958 1.154 19.32 19.32 0 002.556-2.572 11.026 11.026 0 00.186-.235l.011-.015.003-.004.001-.002h.001L21 12.2l.601.449a.75.75 0 000-.897L21 12.2c.601-.448.601-.449.6-.449v-.002l-.004-.004-.01-.015-.015-.018-.025-.033a16.846 16.846 0 00-.695-.825 19.336 19.336 0 00-2.008-1.931C17.166 7.533 14.746 6.05 12 6.05a8.15 8.15 0 00-1.966.247.75.75 0 00.361 1.456zm-4.28 2.324a.75.75 0 10-.958-1.154 19.335 19.335 0 00-2.556 2.572 10.883 10.883 0 00-.186.235l-.011.015-.003.004-.001.002h-.001L3 12.2l-.601-.448a.75.75 0 000 .896L3 12.2l-.6.449v.002l.004.004.01.015a7.782 7.782 0 00.187.235 19.32 19.32 0 002.557 2.573C6.833 16.867 9.253 18.35 12 18.35c.684 0 1.347-.092 1.982-.251a.75.75 0 10-.364-1.455A6.658 6.658 0 0112 16.85c-2.224 0-4.305-1.218-5.885-2.527a17.833 17.833 0 01-2.15-2.123 17.842 17.842 0 012.15-2.123z"}})])
          )
        }
      }
    